/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
// import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutCustomerAccountPaymentViewProps } from './lds-checkout-customer-account-payment-4';
import { IAccountPaymentEditViewForm, IGetAccountPaymentEditViewFormInput } from './components/get-account-payment-form-edit-mode';
import { IAccountPaymentSummaryViewForm } from './components/get-account-payment-form-summary-mode';

//@ts-ignore
import { Primary } from '@churchofjesuschrist/eden-buttons';
import styled from 'styled-components';

import {
    getIdentificationTypesAsync,
    getIdentificationTypesApplicabilityRulesAsync
    // churchValidatePaymentAsync
} from '../../actions/DataActionExtension.g';
// @ts-ignore
import { Secondary } from '@churchofjesuschrist/eden-buttons';

export const SummaryForm: React.FC<IAccountPaymentSummaryViewForm> = ({
    formProps,
    label,
    paymentAmount,
    addPaymentButton,
    appliedLine,
    bottomBorder
}) => (
    <Node {...formProps}>
        <>
            {label}
            {paymentAmount}
            {addPaymentButton}
            {appliedLine}
            {bottomBorder}
        </>
    </Node>
);

export interface EditFormProps {
    accountForm: IAccountPaymentEditViewForm;
    submitProps?: IGetAccountPaymentEditViewFormInput;
}
interface IEditFormExtended extends IAccountPaymentEditViewForm {
    paymentLabel?: string;
    paymentApplied?: string;
}

export const EditForm: React.FC<IEditFormExtended> = ({
    formProps,
    addPaymentButton,
    alert,
    accountDetails,
    appliedLine,
    bottomBorder,
    paymentLabel,
    paymentApplied
}) => {
    const PaymentButtonLabel = styled.div`
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        margin-top: 15px;
    `;
    return (
        <Node {...formProps}>
            <>
                <div>
                    <PaymentButtonLabel>
                        {alert}
                        {/*@ts-ignore */}
                        <Primary {...addPaymentButton.props}>{paymentLabel}</Primary>
                    </PaymentButtonLabel>
                    {appliedLine ? <div>{paymentApplied}</div> : null}
                    {/* {appliedLine} */}
                </div>
                {accountDetails}
                {bottomBorder}
            </>
        </Node>
    );
};

const CheckoutCustomerAccountView: React.FC<ICheckoutCustomerAccountPaymentViewProps> = props => {
    // const { checkoutCustomerAccount, editView, resources, context, updatePaymentAttributes } = props;
    const { editView, resources, context, updatePaymentAttributes } = props;
    const [taxIdResults, setTaxIdResults] = React.useState<any>();
    const [isError, setIsError] = React.useState(false);
    const [idType, setIdType] = React.useState<any>('');
    const [taxId, setTaxId] = React.useState<any>('');
    const [isVisible, setIsVisible] = React.useState<any>(false);
    const [userCountry, setUserCountry] = React.useState<any>();
    const [paymentType, setPaymentType] = React.useState<any>();
    const [updateTaxId, setUpdateTaxId] = React.useState<any>(false);

    const idTypeInputStyle: React.CSSProperties = {
        width: '100%',
        border: isError ? '1px solid red' : '1px solid rgb(135, 138, 140)',
        boxSizing: 'border-box',
        borderRadius: '2px',
        margin: '8px 0px',
        lineHeight: '22px',
        padding: '8px',
        fontSize: '16px',
        fontFamily: `"Ensign:Sans",Arial,"noto sans" ,sans-serif`,
        fontStyle: 'normal'
    };

    const idTypeStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        marginTop: '15px'
    };

    const handleSelect = async (option: any) => {
        const selectedOption = taxIdResults.filter((taxId: any) => {
            return taxId.TypeId === option;
        });
        if (selectedOption && selectedOption[0]) {
            sessionStorage.setItem('TaxId', selectedOption[0].TypeId);
            if (selectedOption[0].Description.toLowerCase().includes('boleta')) {
                setUpdateTaxId(true);
            } else {
                setUpdateTaxId(false);
            }
        }

        setIdType(selectedOption[0].TypeId);
    };

    const onInputChange = (value: any) => {
        if (isError === true) {
            setIsError(false);
        }
        sessionStorage.setItem('idNum', value);
        setTaxId(value);
    };

    const getTaxIdInfo = async () => {
        const ctx = { callerContext: context.actionContext };
        let idTypes;
        // @ts-ignore
        if (props.data.cart && props.data.cart.result) {
            const getUserCountry: any =
                // @ts-ignore
                props.data.cart && props.data.cart.result && props.data.cart.result.cart && props.data.cart.result.cart.ExtensionProperties
                    ? // @ts-ignore
                      props.data.cart.result.cart.ExtensionProperties.filter((property: any) => {
                          return property.Key === 'Country';
                      })
                    : '';
            setUserCountry(getUserCountry);
            sessionStorage.setItem('taxIdRegion', getUserCountry[0].Value.StringValue);

            idTypes = await getIdentificationTypesAsync(ctx, getUserCountry[0].Value.StringValue).catch((err: any) => {
                return console.log(err);
            });
            if (idTypes && idTypes[0]) {
                sessionStorage.setItem('taxIdCheck', 'true');
            } else {
                sessionStorage.setItem('taxIdCheck', 'false');
                setIsVisible(true);
            }
        }

        return setTaxIdResults(idTypes);
    };
    React.useEffect(() => {
        const paymentTypeId = sessionStorage.getItem('paymentTypeId');
        if (paymentTypeId && paymentTypeId === '101') {
            setIsVisible(true);
        }

        setPaymentType(paymentTypeId);
    }, [props]);

    React.useEffect(() => {
        const sessionTaxId = sessionStorage.getItem('TaxId');
        const sessionIdNum = sessionStorage.getItem('idNum');
        if (sessionTaxId) {
            setIdType(sessionTaxId);
            if (sessionTaxId.toLocaleLowerCase().includes('boleta')) {
                setUpdateTaxId(true);
            }
        }
        if (sessionIdNum) {
            setTaxId(sessionIdNum);
        }
        void getTaxIdInfo();
    }, []);

    const insertDash = (str: string) => {
        // Check if the string contains a "-"
        if (str.includes('-')) {
            // If it does, do nothing
            return str;
        } else {
            // If it does not, insert a "-" between the second to last and last characters
            return `${str.slice(0, -1)}-${str.slice(-1)}`;
        }
    };

    const validateCPF = (cpf: any) => {
        // Remove non-digit characters
        cpf = cpf.replace(/[^\d]/g, '');

        // Check if CPF length is 11 characters
        if (cpf.length !== 11) {
            return false;
        }

        // Check for known invalid CPF numbers
        if (
            cpf === '00000000000' ||
            cpf === '11111111111' ||
            cpf === '22222222222' ||
            cpf === '33333333333' ||
            cpf === '44444444444' ||
            cpf === '55555555555' ||
            cpf === '66666666666' ||
            cpf === '77777777777' ||
            cpf === '88888888888' ||
            cpf === '99999999999'
        ) {
            return false;
        }

        // Validate CPF algorithm
        let sum = 0;
        let remainder;

        for (let i = 1; i <= 9; i++) {
            sum += parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
        }
        remainder = (sum * 10) % 11;

        if (remainder === 10 || remainder === 11) {
            remainder = 0;
        }

        if (remainder !== parseInt(cpf.substring(9, 10), 10)) {
            return false;
        }

        sum = 0;
        for (let i = 1; i <= 10; i++) {
            sum += parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
        }
        remainder = (sum * 10) % 11;

        if (remainder === 10 || remainder === 11) {
            remainder = 0;
        }

        if (remainder !== parseInt(cpf.substring(10, 11), 10)) {
            return false;
        }

        return true;
    };

    const onClickCustom = async () => {
        const ctx = { callerContext: context.actionContext };
        let newTaxId: string = taxId;
        const userCountryRegion = sessionStorage.getItem('taxIdRegion');

        if (updateTaxId === true && userCountryRegion && userCountryRegion === 'CHL') {
            newTaxId = insertDash(taxId);
            setTaxId(newTaxId);
        }
        if (userCountry[0].Value.StringValue === 'BRA' && idType === 'CPF') {
            const validCPF = validateCPF(newTaxId);
            if (validCPF === true) {
                setIsVisible(true);
                if (isError === true) {
                    setIsError(false);
                }
            } else {
                setIsError(true);
            }
        } else {
            const taxIdCheck = await getIdentificationTypesApplicabilityRulesAsync(
                ctx,
                userCountry[0].Value.StringValue,
                idType,
                newTaxId
            ).catch(err => {
                console.log(err);
                setIsError(true);
            });

            if (taxIdCheck) {
                await updatePaymentAttributes(idType, newTaxId).then(() => {
                    setIsVisible(true);
                });
            }
        }
    };

    // const { checkoutCustomerAccount, summaryView, editView, moduleState } = props;
    //@ts-ignore
    const paymentLabel = props.resources.applyPaymentLabel;
    //@ts-ignore
    const paymentApplied = props.resources.paymentApplied;
    return (
        <>
            {taxIdResults && taxIdResults[0] && paymentType !== '101' ? (
                <div style={idTypeStyle}>
                    <label>{resources.taxIdLabel}</label>
                    <select style={idTypeInputStyle} onChange={(e: any) => handleSelect(e.target.value)} disabled={isVisible}>
                        <option value='' disabled selected>
                            {resources.taxIdPlaceholder}
                        </option>
                        {taxIdResults && taxIdResults[0]
                            ? taxIdResults.map((taxId: any) => {
                                  return (
                                      <option value={taxId.TypeId} key={taxId.Id} selected={idType === taxId.TypeId}>
                                          {taxId.Description}
                                      </option>
                                  );
                              })
                            : null}
                    </select>
                    <label>{resources.taxIdInputLabel}</label>
                    <input
                        type='text'
                        style={idTypeInputStyle}
                        onChange={(e: any) => onInputChange(e.target.value)}
                        value={taxId}
                        disabled={isVisible}
                    />
                    {isError && <small>{resources.taxIdErrorMessage}</small>}
                    {isVisible === false && <Secondary onClick={() => onClickCustom()}>{resources.applyPaymentLabel}</Secondary>}
                </div>
            ) : null}
            {editView && isVisible && <EditForm {...editView} paymentLabel={paymentLabel} paymentApplied={paymentApplied} />}
        </>
    );
};

export default CheckoutCustomerAccountView;
